import React from "react";
import BillsToBePaid from "./BillsToBePaid";
import DrawStudentsNameAndTotal from "./DrawStudentsNameAndTotal";
import DrawNextBillDate from "./DrawNextBillDate";

/**
 * Renders the list of students with their unpaid bills, next bill dates, and toggles.
 * @date 2026-04-15
 * @version 2.0
 * @author Forge, opencode + glm-5
 */
export default function DrawBills(props) {
  let { payment } = props;
  return (
    <div>
      {payment.students
        .filter((student) => student.unpaidBills.length > 0)
        .map((student, i) => (
          <div
            key={student._id}
            className="flex justify-between border border-slate-200 rounded-[10px] m-2 p-3"
          >
            <div className="flex-1">
              <DrawStudentsNameAndTotal student={student} {...props} />
              {!payment.excludedStudents.includes(student._id) ? (
                <BillsToBePaid student={student} {...props} />
              ) : null}
            </div>
            <DrawNextBillDate student={student} {...props} />
          </div>
        ))}
    </div>
  );
}